import React, { useState } from 'react'
import { Container, Row, Col, Button, Table, Badge } from 'react-bootstrap'
import Swal from 'sweetalert2'

import Card from '../../../components/Card'
import ProfileHeader from '../../../components/profile-header'
import img6 from '../../../assets/images/page-img/profile-bg6.jpg'
import NoDataFound from '../../../components/noDataFound'

const SUBSIDY_STORAGE_KEY = 'harmonydaycare_subsidy_records'

const getSubsidyRecords = () => {
  try {
    const raw = localStorage.getItem(SUBSIDY_STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (error) {
    return []
  }
}

const saveSubsidyRecords = (records) => {
  localStorage.setItem(SUBSIDY_STORAGE_KEY, JSON.stringify(records))
}

const formatDate = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  return date.toLocaleDateString()
}

const Subsidy = () => {
  const [records, setRecords] = useState(getSubsidyRecords())

  const handleRemoveSubsidy = (id) => {
    Swal.fire({
      title: 'Remove Subsidy',
      text: 'Are you sure you want to remove this subsidy record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Remove',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = records.filter((record) => record.id !== id)
        setRecords(updated)
        saveSubsidyRecords(updated)
        Swal.fire('Removed', 'Subsidy record removed.', 'success')
      }
    })
  }

  return (
    <>
      <ProfileHeader title="Subsidy" img={img6} />
      <div id="content-page" className="content-page">
        <Container>
          <Row className="g-4">
            <Col lg={12}>
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div className="header-title">
                    <h5 className="card-title mb-0">Subsidy Records</h5>
                  </div>
                  <Badge bg="primary" pill>{records.length} Records</Badge>
                </Card.Header>
                <Card.Body>
                  {records.length === 0 ? (
                    <NoDataFound txtData="No subsidy records found." />
                  ) : (
                    <div className="table-responsive">
                      <Table hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th>Child</th>
                            <th>Program</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Added</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records.map((record) => (
                            <tr key={record.id}>
                              <td>{record.childName}</td>
                              <td>{record.program}</td>
                              <td>${record.amount}</td>
                              <td>
                                <Badge bg="success">{record.status}</Badge>
                              </td>
                              <td>{formatDate(record.createdAt)}</td>
                              <td className="text-end">
                                <Button variant="outline-danger" size="sm" onClick={() => handleRemoveSubsidy(record.id)}>
                                  Remove
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Subsidy
